import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import dayjs from "dayjs";
import SelectDropDown from "./SelectDropDown";
import { useParams } from "react-router-dom";
import { useAuthDetails } from "../Common/cookiesHelper";
import { Skeleton } from "@mui/material";
import SelectDropDownWithCheckBox from "./SelectDropDownWithCheckBox";
import axios from "axios";
import { getManagerStoresCached } from "./managerStoresCache";
import Config from "../Constants/Config";
import useMultiSelectForDashDaterange from "../hooks/useMultiSelectForDashDaterange";
import { ToastifyAlert } from "../CommonComponents/ToastifyAlert";
import {
  DATE_FILTER_POPPER_CLASS,
  DateFilterHeading,
  DateFilterPresets,
  ReadOnlyDateInput,
} from "./DateFilterParts";
import { ciUrl } from "../Constants/nodeCi";
const DashDateRangeComponent = ({
  onDateRangeChange,
  selectedDateRange,
  future_date,
  setCurrentPage,
  usingFor,
  timeComponent = false,
  AllInSystemAccessState = [],
  timeloading = false,
  disabled = true,
  maxRangeDays = null,
  // Fires with the comma-joined merchant_ids every time the Outlet selection
  // changes, WITHOUT waiting for Search. onDateRangeChange is gated behind the
  // Search button, which is right for running a report but wrong for filter
  // dropdowns that have to list options for the stores currently ticked.
  // Mirrors the prop of the same name on CommonDateRangeComponent.
  onStoreSelectionChange,
}) => {
  const fieldId = React.useId();
  const { selectedReport } = useParams();
  const { LoginGetDashBoardRecordJson, userTypeData, GetSessionLogin } = useAuthDetails();
  const [storeLoading, setStoreLoading] = useState(true);
  const { merchant_id, email: login_user_email } =
    LoginGetDashBoardRecordJson?.data;

  const StoreName = !!LoginGetDashBoardRecordJson?.data?.name
    ? LoginGetDashBoardRecordJson?.data?.name
    : "";
  let last7Days = new Date();
  let dayBeforeDay = new Date();

  const [isTablet, setIsTablet] = useState(false);
  const [startDate, setStartDate] = useState(
    new Date()
    // selectedReport === "sales-summary"
    //   ? new Date()
    //   : last7Days.setDate(new Date().getDate() - 7)
  );
  const [endDate, setEndDate] = useState(
    new Date()
    // selectedReport === "sales-summary"
    //   ? new Date()
    //   : dayBeforeDay.setDate(new Date().getDate() - 1)
  );
  const [storeList, setStoreList] = useState([]);
  const {
    selectedItems: selectedStoreList,
    allOptionSelected: allStoreSelected,
    handleOptionClick: handleStoreClick,
  } = useMultiSelectForDashDaterange(storeList);
  // [currentStoreData]
  // .filter((store) => store.id === merchant_id)
  const [futureDateState, setFutureDate] = useState(new Date());
  // const [time, setTime] = useState({
  //   start_time: startDate.setHours(8, 0, 0, 0),
  //   end_time: endDate.setHours(22, 0, 0, 0),
  // });
  const [time, setTime] = useState({
    start_time: null,
    end_time: null,
  });

  const parseTimeStringToDate = (timeString, baseDate = new Date()) => {
    if (!timeString) return null;
    const [hours, minutes, seconds] = timeString.split(":").map(Number);
    const date = new Date(baseDate);
    date.setHours(hours, minutes || 0, seconds || 0, 0);
    return date;
  };

  useEffect(() => {
    if (timeComponent && AllInSystemAccessState) {
      const { hours_rep_start_time, hours_rep_end_time } =
        AllInSystemAccessState?.systemAccessData;
      const newStart = new Date(startDate);
      const newEnd = new Date(endDate);
      if (hours_rep_start_time && hours_rep_end_time) {
        setTime({
          start_time: parseTimeStringToDate(hours_rep_start_time, startDate),
          end_time: parseTimeStringToDate(hours_rep_end_time, endDate),
        });
      } else {
        setTime({
          start_time: new Date(newStart.setHours(8, 0, 0, 0)),
          end_time: new Date(newEnd.setHours(22, 0, 0, 0)),
        });
      }
    }
  }, [AllInSystemAccessState, timeComponent, startDate, endDate]);

  const handleTimeChange = (type, value) => {
    if (type === "start_time") {
      setTime((prev) => ({
        ...prev,
        start_time: value,
        end_time:
          prev.end_time && value && prev.end_time < value
            ? null
            : prev.end_time,
      }));
    } else if (type === "end_time") {
      // only allow end_time >= start_time
      if (time.start_time && value < time.start_time) {
        alert("End time cannot be earlier than start time!");
        return;
      }
      setTime((prev) => ({ ...prev, end_time: value }));
    }
  };

  // Optional cap (in days, inclusive) on how wide the start/end pair may be.
  const rangeLimitDays =
    Number(maxRangeDays) > 0 ? Math.floor(Number(maxRangeDays)) : null;

  const getSelectedRangeDays = () => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);
    return Math.floor((end - start) / (24 * 60 * 60 * 1000)) + 1;
  };

  const handleSearch = () => {
    if (rangeLimitDays && startDate && endDate) {
      const selectedDays = getSelectedRangeDays();
      if (selectedDays > rangeLimitDays) {
        ToastifyAlert(
          `You can select a maximum of ${rangeLimitDays} days.`,
          "error"
        );
        return;
      }
    }

    const formatDate = (date) => {
      return new Intl.DateTimeFormat("en-CA", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(date);
    };

    const formattedStartDate = formatDate(startDate);
    const formattedEndDate = formatDate(endDate);
    const dateRangeData = {
      start_date: formattedStartDate,
      end_date: formattedEndDate,
      stores: selectedStoreList?.map((store) => store.merchant_id).join(","),
      ...(timeComponent && {
        start_time: time.start_time
          ? dayjs(time.start_time).format("HH:mm")
          : null,
        end_time: time.end_time ? dayjs(time.end_time).format("HH:mm") : null,
      }),
    };
    if (usingFor === "resetPagination") {
      setCurrentPage(1);
    }
    onDateRangeChange(dateRangeData);
  };

  const [activeOption, setActiveOption] = useState(
    "Today"
    // selectedReport !== "sales-summary" ? "Last 7 Days" : "Today"
  );

  const setActive = (option) => {
    setActiveOption(option);
  };

  const isActive = (option) => {
    return option === activeOption;
  };

  const setDatesBasedOnOption = (option) => {
    const today = new Date();
    const dayBeforeDay = new Date();
    switch (option) {
      case "Today":
        setStartDate(today);
        setEndDate(today);
        break;
      case "Yesterday":
        const yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);
        setStartDate(yesterday);
        setEndDate(yesterday);
        break;
      case "Last 7 Days":
        const last7Days = new Date();

        dayBeforeDay.setDate(today.getDate());
        last7Days.setDate(today.getDate() - 6);
        setStartDate(last7Days);
        setEndDate(dayBeforeDay);
        break;
      case "Last 30 Days":
        const thirtyDaysAgo = new Date(today);
        thirtyDaysAgo.setDate(today.getDate() - 29);
        dayBeforeDay.setDate(today.getDate());
        setStartDate(thirtyDaysAgo);
        setEndDate(dayBeforeDay);
        break;
      default:
        break;
    }
  };
  // useEffect(() => {
  //   let count = 0;
  //   if (selectedDateRange && selectedDateRange && count <= 0) {
  //     setStartDate(new Date(selectedDateRange.start_date));
  //     setEndDate(new Date(selectedDateRange.end_date));
  //     // onDateRangeChange({start_date:selectedDateRange.start_date,end_date:selectedDateRange.end_date});
  //     count++;
  //   }
  // }, [selectedDateRange]);
  useEffect(() => {
    const today = new Date();
    let gotFurureDate = new Date();
    future_date &&
      setFutureDate(
        gotFurureDate.setDate(today.getDate() + (parseInt(future_date) + 1))
      );
  }, [future_date]);

  // Search when a quick option is picked or the Outlet selection changes.
  // This used to re-apply the quick option's dates here too, so ticking an
  // outlet after picking dates by hand snapped the range back to "Today" (the
  // option never cleared). The quick-option click already sets its own dates
  // in the same render, so nothing else needs them re-applied.
  const previousOptionRef = React.useRef(activeOption);
  useEffect(() => {
    // The option was just cleared by a hand-picked date: that waits for
    // Search, as picking a date always has.
    const clearedByDatePick =
      activeOption === null && previousOptionRef.current !== null;
    previousOptionRef.current = activeOption;
    if (clearedByDatePick) return;
    handleSearch();
  }, [activeOption, selectedStoreList]);

  const loadStoreOptions = async (inputValue) => {
    try {
      const payload = {
        name: inputValue || "", // filter by input
        merchant_id: merchant_id,
        email: userTypeData?.login_type === "superadmin" ? LoginGetDashBoardRecordJson?.data?.email : GetSessionLogin?.username,
        ...userTypeData,
      };
      const { token, ...splitData } = payload;
      const response = await (inputValue
        ? axios.post(
            ciUrl(Config.GET_ALL_MANAGER_STORES),
            splitData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${LoginGetDashBoardRecordJson?.token}`,
              },
            }
          )
        : getManagerStoresCached(merchant_id, () =>
            axios.post(
              ciUrl(Config.GET_ALL_MANAGER_STORES),
              splitData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization: `Bearer ${LoginGetDashBoardRecordJson?.token}`,
                },
              }
            )
          ));
      if (response.data.status && response.data.data.length > 0) {
        // Map data to { value, label } format for AsyncSelect
        const options = response.data.data.map((store) => ({
          value: store.merchant_id,
          merchant_id: store.merchant_id,
          name: store.name,
          title: store.name,
          label: store.name,
          raw: store,
          id: store.merchant_id,
        }));
        setStoreList(options);
      } else {
        return [];
      }
    } catch (err) {
      console.error("Error fetching stores", err);
      return [];
    }
  };

  useEffect(() => {
    if (disabled) return;
    loadStoreOptions();
  }, []);

  // Same merchant_id list handleSearch builds, but published live so filter
  // dropdowns can follow the Outlet picker instead of the Search button.
  const liveOutletIds = Array.isArray(selectedStoreList)
    ? selectedStoreList
        .map((store) => store?.merchant_id ?? store?.id ?? store?.value)
        .filter(Boolean)
        .map(String)
        .join(",")
    : "";

  useEffect(() => {
    if (typeof onStoreSelectionChange === "function") {
      onStoreSelectionChange(liveOutletIds);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [liveOutletIds]);
  // Trigger skeleton for 1 second on component mount
  useEffect(() => {
    setStoreLoading(true);
    const timer = setTimeout(() => {
      setStoreLoading(false);
    }, 1000); // 1 second

    return () => clearTimeout(timer);
  }, []);

  // useEffect(() => {
  //   const formatDate = (date) => {
  //     return new Intl.DateTimeFormat("en-CA", {
  //       year: "numeric",
  //       month: "2-digit",
  //       day: "2-digit",
  //     }).format(date);
  //   };

  //   const formattedStartDate = formatDate(startDate);
  //   const formattedEndDate = formatDate(endDate);
  //   const dateRangeData = {
  //     start_date: formattedStartDate,
  //     end_date: formattedEndDate,
  //     ...(timeComponent && {
  //       start_time: time.start_time
  //         ? dayjs(time.start_time).format("HH:mm")
  //         : null,
  //       end_time: time.end_time ? dayjs(time.end_time).format("HH:mm") : null,
  //     }),
  //   };

  //   onDateRangeChange(dateRangeData);
  // }, [startDate, endDate]);

  const [selectedReportList, setSelectedReportList] = useState(StoreName);

  const selectReportList = [
    {
      title: StoreName,
    },
  ];

  const handleOptionClick = (option, dropdown) => {
    switch (dropdown) {
      case "reportList":
        setSelectedReportList(option.title);
        break;

      default:
        break;
    }
  };
  const addDays = (date, days) => {
    const next = new Date(date);
    next.setDate(next.getDate() + days);
    return next;
  };

  // Honour whichever end the user just picked and auto-shift the other one
  // so the pair never spans more than maxRangeDays.
  // A hand-picked date is a custom range, so no quick option is active any
  // more - left highlighted, it claimed "Today" over a 10/01-10/15 range and
  // clicking "Today" again could not apply it.
  const handleStartDateChange = (date) => {
    setActiveOption(null);
    setStartDate(date);
    if (!rangeLimitDays || !date) return;
    const latestAllowedEnd = addDays(date, rangeLimitDays - 1);
    const upperBound = new Date(futureDateState ? futureDateState : new Date());
    if (endDate && new Date(endDate).getTime() > latestAllowedEnd.getTime()) {
      setEndDate(
        new Date(Math.min(latestAllowedEnd.getTime(), upperBound.getTime()))
      );
    }
  };

  const handleEndDateChange = (date) => {
    setActiveOption(null);
    setEndDate(date);
    if (!rangeLimitDays || !date) return;
    const earliestAllowedStart = addDays(date, -(rangeLimitDays - 1));
    if (
      startDate &&
      new Date(startDate).getTime() < earliestAllowedStart.getTime()
    ) {
      setStartDate(earliestAllowedStart);
    }
  };

  return (
    <div className="q-datarange-bottom-detail-section qv-date-filter">
      <DateFilterHeading />
      <DateFilterPresets
        isActive={isActive}
        onSelect={(option) => {
          setActive(option);
          setDatesBasedOnOption(option);
        }}
      />

      <div className="qv-date-filter__fields">
        <div className="qv-date-filter__field">
          <label htmlFor={`${fieldId}-start`} className="qv-date-filter__label">
            Start Date
          </label>
          <DatePicker
            id={`${fieldId}-start`}
            selected={startDate}
            onChange={handleStartDateChange}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            maxDate={endDate}
            dateFormat="MM/dd/yyyy"
            showPopperArrow={false}
            popperPlacement="bottom-start"
            popperClassName={DATE_FILTER_POPPER_CLASS}
            customInput={<ReadOnlyDateInput />}
          />
        </div>
        <div className="qv-date-filter__field">
          <label htmlFor={`${fieldId}-end`} className="qv-date-filter__label">
            End Date
          </label>
          <DatePicker
            id={`${fieldId}-end`}
            selected={endDate}
            onChange={handleEndDateChange}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            maxDate={futureDateState ? futureDateState : new Date()} // Set maxDate to today's date
            dateFormat="MM/dd/yyyy"
            showPopperArrow={false}
            popperPlacement="bottom-start"
            popperClassName={DATE_FILTER_POPPER_CLASS}
            customInput={<ReadOnlyDateInput />}
          />
        </div>
        <div className="qv-date-filter__field">
          <span className="qv-date-filter__label">Outlet</span>
          <div className="OutletDropDown">
            {storeLoading ? (
              <Skeleton variant="rectangular" width="100%" height={40} />
            ) : (
              <SelectDropDownWithCheckBox
                options={storeList}
                heading={"All"}
                title="name"
                label={
                  selectedStoreList?.length === 1
                    ? selectedStoreList[0].name
                    : "Stores"
                }
                onClickHandler={handleStoreClick}
                selectedOption={selectedStoreList}
                allOptionSelected={allStoreSelected}
                disabled={disabled}
              />
            )}
          </div>
        </div>
        <div className="qv-date-filter__field qv-date-filter__field--action">
          <button type="button" onClick={handleSearch} className="save_btn">
            Search
          </button>
        </div>
      </div>

      {timeComponent && (
        <div className="qv-date-filter__fields">
          <div className="qv-date-filter__field qv-date-filter__field--time">
            <label htmlFor={`${fieldId}-start-time`} className="qv-date-filter__label">
              Start Time
            </label>
            {timeloading ? (
              <Skeleton variant="rectangular" width="100%" height={40} />
            ) : (
              <DatePicker
                id={`${fieldId}-start-time`}
                selected={time.start_time}
                onChange={(date) => handleTimeChange("start_time", date)}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={30}
                timeCaption="Start Time"
                dateFormat="h:mm aa"
                placeholderText="Select Start Time"
                className="qv-date-filter__input"
              />
            )}
          </div>
          <div className="qv-date-filter__field qv-date-filter__field--time">
            <label htmlFor={`${fieldId}-end-time`} className="qv-date-filter__label">
              End Time
            </label>
            {!timeloading && (
              <DatePicker
                id={`${fieldId}-end-time`}
                selected={time.end_time}
                onChange={(date) => handleTimeChange("end_time", date)}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={30}
                timeCaption="End Time"
                dateFormat="h:mm aa"
                placeholderText="Select End Time"
                className="qv-date-filter__input"
                minTime={time.start_time || new Date().setHours(0, 0, 0, 0)}
                maxTime={new Date().setHours(23, 59, 59, 999)}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DashDateRangeComponent;
